import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import NityaContent from "./components/NityaContent/NityaContent";
import NityaSevak from "./components/NityaSevak/NityaSevak";
import NityaContribution from "./components/NityaContribution/NityaContribution";
import img from "./assets/images/img.webp";
import mainBanner from "./assets/images/mainBanner1.webp";
import barcode1 from "./assets/images/barcode1.webp";
import barcode2 from "./assets/images/barcode2.webp";
// import becomeNityaSevakCard from "./assets/images/becomeNityaSevakCard.webp";
import NityaSevaCard from "./components/NityaSevakCard/NityaSevacard";
import "./NityaSeva.css";
import { Helmet } from "react-helmet-async";

const NityaSeva = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Daily Seva at ISKCON Vijayawada – Nitya Seva Opportunities
        </title>
        <meta
          name="description"
          content="Support ISKCON Vijayawada’s Nitya Seva by sponsoring daily offerings and temple services for spiritual merit, divine blessings, and Krishna’s satisfaction."
        />
        <meta
          name="keywords"
          content="Nitya Seva ISKCON, daily temple seva, Krishna daily offerings, ISKCON sponsorship"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Daily Seva at ISKCON Vijayawada – Nitya Seva Opportunities"
        />
        <meta
          property="og:description"
          content="Support ISKCON Vijayawada’s Nitya Seva by sponsoring daily offerings and temple services for spiritual merit, divine blessings, and Krishna’s satisfaction."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/nitya-seva"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Daily Seva at ISKCON Vijayawada – Nitya Seva Opportunities"
        />
        <meta
          name="twitter:description"
          content="Support ISKCON Vijayawada’s Nitya Seva by sponsoring daily offerings and temple services for spiritual merit, divine blessings, and Krishna’s satisfaction."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/nitya-seva"
        />
      </Helmet>

      <Header />
      <div className="nitya-seva-page">
        <div className="banner-container">
          <div className="image-wrapper">
            <img
              loading="lazy"
              src={mainBanner}
              alt="Main Banner"
              className="nitya-seva-banner"
            />
            <div className="text-overlay">
              <h2 className="main-heading">Become A</h2>
              <h1 className="main-heading2">Nitya Sevak</h1>
              <p className="sub-heading">
                स्वकर्मणा तमभ्यर्च्य सिद्धिं विन्दति मानव:
              </p>
              <p className="sub-heading2">Make your Work, A Worship</p>
            </div>
          </div>
        </div>
        {/* <div>
          <img
            loading="lazy"
            src={mainBanner}
            alt="Main Banner"
            className="nitya-seva-banner"
          />
        </div> */}
        <NityaContent />
        <div className="d-flex justify-content-center">
          <h5 className="head-nitya-seva">
            "Nitya Seva is a monthly donation program where a devotee like you
            can monthly contribute in the lotus feet of the Lord."
          </h5>
        </div>
        <div
          className="d-flex justify-content-center"
          style={{ padding: "2em 0" }}
        >
          {/* <img
            loading="lazy"
            src={img}
            alt="nitya-seva"
            className="nitya-seva-img"
          /> */}
        </div>

        <NityaSevaCard />
        <NityaSevak />
        <NityaContribution />

        {/* donation Through Bank */}

        <div className="mx-2">
          <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-5 justify-center items-center  overflow-hidden">
            <h2 className="md:py-4 py-3 bg-[#C61D21] text-white text-center md:text-3xl text-base">
              Donation Through Bank (NEFT/RTGS){" "}
            </h2>
            <div className="flex justify-center items-center">
              <ul className="flex flex-col justify-center items-center leading-4 space-y-4 list-none px-0 mx-0  my-2">
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className="md:text-2xl text-[15px] text-[#C61D21] ">
                    Bank Name:<span className="text-black"> HDFC Bank</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("HDFC Bank", "bankName")}
                  >
                    {copiedText === "bankName" ? "Copied!" : "Copy"}
                  </button>
                </li>

                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className="md:text-2xl text-[15px] text-[#C61D21]">
                    Account Name:<span className="text-black"> ISKCON</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5  border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("ISKCON", "accountName")}
                  >
                    {copiedText === "accountName" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className=" text-[#C61D21]">
                    Account Number:{" "}
                    <span className="text-black">50100436709020</span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() =>
                      copyToClipboard("50100436709020", "accountNumber")
                    }
                  >
                    {copiedText === "accountNumber" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px]  leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal ">
                  <span className=" text-[#C61D21]">
                    IFSC Code: <span className="text-black">HDFC000568</span>
                  </span>
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() => copyToClipboard("HDFC000568", "ifscCode")}
                  >
                    {copiedText === "ifscCode" ? "Copied!" : "Copy"}
                  </button>
                </li>
                <li className="w-full md:text-2xl text-[15px] leading-2 tracking-none font-bold text-black px-2 md:px-0 flex justify-between md:justify-normal">
                  <span className=" text-[#C61D21]">
                    Branch:{" "}
                    <span className="text-black">ONE TOWN VIJAYAWADA </span>
                  </span>{" "}
                  <button
                    class="bg-gray-200 md:text-xs text-[10px] px-2 md:py-0.5 border-1 border-[#C61D21] ml-2 rounded-full"
                    onClick={() =>
                      copyToClipboard("ONE TOWN VIJAYAWADA", "branch")
                    }
                  >
                    {copiedText === "branch" ? "Copied!" : "Copy"}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* UPI Payment */}
        <div className="mx-2">
          <div className="md:mx-44  md:border-5 border-2 md:rounded-2xl rounded-lg border-[#C61D21] mt-10 overflow-hidden">
            <h2 className="md:py-4 py-2 bg-[#C61D21] text-white text-center md:text-3xl text-base">
              Donate Through UPI
            </h2>

            <div className="flex md:flex-row flex-col justify-around items-center pt-3 md:pb-3 pb-4 gap-4">
              <div className="md:block flex gap-2 px-1">
                <h2 className="md:text-2xl text-sm text-[#C61D21]">UPI ID:</h2>
                <p className="md:text-xl text-sm  text-black">
                  {" "}
                  ISCKONVIJAYAWADA@IDFCBANK
                </p>
              </div>
              <img
                loading="lazy"
                src={barcode1}
                alt=""
                width="200px"
                height="200px"
              />
              <span className="font-bold">OR</span>
              <img
                loading="lazy"
                src={barcode2}
                alt=""
                width="200px"
                height="200px"
              />
            </div>
          </div>

          <div className="text-left md:mx-44 mt-5 pb-10">
            <h2 className="text-3xl  text-[#C61D21] text-left font-bold">
              After Donation:
            </h2>
            <p className="md:text-2xl mt-4 text-base text-black w-full text-justify font-semibold">
              Once you have donated, please share the transaction details or
              receipt via WhatsApp at{" "}
              <span className="text-red">+91 9955685568</span>. This helps us
              acknowledge your contribution and issue a receipt for tax
              exemption under Section 80G of the Income Tax Act.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NityaSeva;
